import React, { useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/material";
import moment from "moment";
import QTDetailsTextFieldWithLabelSection from "../../../../../common/QTDetailsTextFieldWithLabelSection";
import QTDetailsAutoCompleteWithLabelSection from "../../../../../common/QTDetailsAutoCompleteWithLabelSection";
import { useContributorsContext } from "../../../../../providers/OrganizationAdmin/ContributorsProvider";
import { useAuth } from "../../../../../hooks";

const GroupDetailsDataFieldsSection = ({ groupDetails, setGroupDetails, editEnabled }) => {
  const { currentUser } = useAuth();
  const { GAUsers, handleGetAllGAUsers } = useContributorsContext();

  useEffect(() => {
    if (GAUsers && GAUsers?.length > 0) {
    } else {
      handleGetAllGAUsers();
    }
  }, []);

  const usersData = useMemo(() => {
    const users = Array.isArray(GAUsers) ? GAUsers : [];
    return users
      .filter((u) => u)
      .filter((u) => u?.isActive !== false)
      .filter((u) => {
        const first = (u?.firstName || "").trim().toLowerCase();
        const last = (u?.lastName || "").trim().toLowerCase();
        return !(first === "guest" && last === "user");
      });
  }, [GAUsers]);

  // Default Created By to current admin's userId when missing
  useEffect(() => {
    if (groupDetails?.createdBy) return;
    const currentUserId = currentUser?.userId;
    if (!currentUserId) return;
    const match = usersData.find((u) => u?.id === currentUserId);
    if (!match) return;
    setGroupDetails((prev) => ({
      ...prev,
      createdBy: match.id,
      createdByData: match,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser?.userId, usersData, groupDetails?.createdBy]);

  return (
    <Grid container style={{ dataContainerStyles }}>
      {/* left */}
      <Grid item container direction={"column"} xs>
        <QTDetailsTextFieldWithLabelSection
          label={"Group Name"}
          value={groupDetails?.name ?? ""}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) => setGroupDetails({ ...groupDetails, name: e.target.value })}
        />
        <QTDetailsTextFieldWithLabelSection
          label={"Group ID"}
          value={groupDetails?.id ?? ""}
          disabled={true}
        />
        <QTDetailsAutoCompleteWithLabelSection
          label={"Created By"}
          value={
            groupDetails?.createdByData != null
              ? (() => {
                  const first = groupDetails?.createdByData?.firstName || "";
                  const last = groupDetails?.createdByData?.lastName || "";
                  const userName = groupDetails?.createdByData?.userName || "";
                  const displayName = `${first} ${last}`.trim();
                  return userName ? `@${userName}/${displayName}` : displayName;
                })()
              : groupDetails?.createdBy || ""
          }
          onChange={(docData) => {
            if (docData?.id) {
              setGroupDetails({
                ...groupDetails,
                createdByData: docData,
                createdBy: docData.id,
              });
            }
          }}
          disabled={true}
          optionsData={usersData}
          editEnabled={editEnabled}
        />
        <QTDetailsTextFieldWithLabelSection
          label={"Creation Date"}
          value={
            groupDetails?.createdAt?.seconds
              ? moment.unix(groupDetails.createdAt.seconds).format("MM-DD-YYYY HH:mm")
              : ""
          }
          disabled={true}
        />
      </Grid>

      {/* right */}
      <Grid item container direction={"column"} xs>
        <QTDetailsTextFieldWithLabelSection
          label={"Description"}
          value={groupDetails?.description ?? ""}
          disabled={true}
          multiline={true}
          rows={3}
          editEnabled={editEnabled}
          onChange={(e) =>
            setGroupDetails({ ...groupDetails, description: e.target.value })
          }
        />
        <QTDetailsTextFieldWithLabelSection
          label={"Status"}
          value={
            editEnabled
              ? groupDetails?.status
                ? groupDetails.status.charAt(0).toUpperCase() +
                  groupDetails.status.slice(1).toLowerCase()
                : ""
              : groupDetails?.status
          }
          disabled={true}
          editEnabled={editEnabled}
          select={true}
          dropdownValues={["Active", "Draft", "Inactive"]}
          onChange={(e) =>
            setGroupDetails({ ...groupDetails, status: (e.target.value || "").toLowerCase() })
          }
        />
      </Grid>
    </Grid>
  );
};

export default GroupDetailsDataFieldsSection;

const dataContainerStyles = {
  borderRadius: 12,
  boxShadow: " 0px 0px 30px 0px rgba(80, 85, 136, 0.15)",
  background: "var(--gray-99, #FCFCFC)",
  padding: "36px 15px",
  marginBottom: 30,
};
